/* TFG-030-DI */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.store-showroom');
  if (!root) return;

  root.querySelectorAll('.contact-support-trigger').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();
      if (typeof zE === 'undefined') return;

      try {
        zE('messenger', 'open');
        return;
      } catch (error) {
        /* Zendesk messenger unavailable */
      }

      try {
        zE('webWidget', 'show');
        zE('webWidget', 'open');
      } catch (error) {
        /* Zendesk webWidget unavailable */
      }
    });
  });
});
